import script from "./plantInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./plantInfo.vue?vue&type=script&setup=true&lang=js"

import "./plantInfo.vue?vue&type=style&index=0&id=3479de82&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3479de82"]])

export default __exports__